export const errorMessages = {
	TEST_NOT_FOUND: 'Oops! It looks like we encountered an issue loading the test. Please contact Jobox Support for assistance.',
};
